import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../components/ui/Card";
import { Badge } from "../../../components/ui/Badge";
import { ArrowRight } from "lucide-react";

const CategoryCard = ({ title, description, articleCount, icon: Icon, color, onClick }) => {
  return (
    <Card 
      className="group cursor-pointer transition-smooth hover:shadow-elegant hover:-translate-y-1 border-2 border-transparent hover:border-primary/20"
      onClick={onClick}
    >
      <CardHeader>
        <div className="flex items-start justify-between">
          <div className={`p-3 rounded-lg ${color} bg-opacity-10`}>
            <Icon className={`h-6 w-6 ${color.replace('bg-', 'text-')}`} />
          </div>
          <Badge variant="secondary" className="bg-muted">
            {articleCount} articles
          </Badge>
        </div>
        <CardTitle className="mt-4 group-hover:text-primary transition-smooth">
          {title}
        </CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center text-sm font-medium text-primary group-hover:gap-2 transition-smooth">
          Browse articles
          <ArrowRight className="h-4 w-4 ml-1 group-hover:translate-x-1 transition-smooth" />
        </div>
      </CardContent>
    </Card>
  );
};

export default CategoryCard;
